export enum ProjectEmailTemplateLocale {
    Af = 'af',
    Arae = 'ar-ae',
    Arbh = 'ar-bh',
    Ardz = 'ar-dz',
    Areg = 'ar-eg',
    Ariq = 'ar-iq',
    Arjo = 'ar-jo',
    Arkw = 'ar-kw',
    Arlb = 'ar-lb',
    Arly = 'ar-ly',
    Arma = 'ar-ma',
    Arom = 'ar-om',
    Arqa = 'ar-qa',
    Arsa = 'ar-sa',
    Arsy = 'ar-sy',
    Artn = 'ar-tn',
    Arye = 'ar-ye',
    As = 'as',
    Az = 'az',
    Be = 'be',
    Bg = 'bg',
    Bh = 'bh',
    Bn = 'bn',
    Bs = 'bs',
    Ca = 'ca',
    Cs = 'cs',
    Cy = 'cy',
    Da = 'da',
    De = 'de',
    Deat = 'de-at',
    Dech = 'de-ch',
    Deli = 'de-li',
    Delu = 'de-lu',
    El = 'el',
    En = 'en',
    Enau = 'en-au',
    Enbz = 'en-bz',
    Enca = 'en-ca',
    Engb = 'en-gb',
    Enie = 'en-ie',
    Enjm = 'en-jm',
    Ennz = 'en-nz',
    Entt = 'en-tt',
    Enus = 'en-us',
    Enza = 'en-za',
    Eo = 'eo',
    Es = 'es',
    Esar = 'es-ar',
    Esbo = 'es-bo',
    Escl = 'es-cl',
    Esco = 'es-co',
    Escr = 'es-cr',
    Esdo = 'es-do',
    Esec = 'es-ec',
    Esgt = 'es-gt',
    Eshn = 'es-hn',
    Esmx = 'es-mx',
    Esni = 'es-ni',
    Espa = 'es-pa',
    Espe = 'es-pe',
    Espr = 'es-pr',
    Espy = 'es-py',
    Essv = 'es-sv',
    Esuy = 'es-uy',
    Esve = 'es-ve',
    Et = 'et',
    Eu = 'eu',
    Fa = 'fa',
    Fi = 'fi',
    Fo = 'fo',
    Fr = 'fr',
    Frbe = 'fr-be',
    Frca = 'fr-ca',
    Frch = 'fr-ch',
    Frlu = 'fr-lu',
    Ga = 'ga',
    Gd = 'gd',
    He = 'he',
    Hi = 'hi',
    Hr = 'hr',
    Hu = 'hu',
    Id = 'id',
    Is = 'is',
    It = 'it',
    Itch = 'it-ch',
    Ja = 'ja',
    Ji = 'ji',
    Ko = 'ko',
    Ku = 'ku',
    Lt = 'lt',
    Lv = 'lv',
    Mk = 'mk',
    Ml = 'ml',
    Ms = 'ms',
    Mt = 'mt',
    Nb = 'nb',
    Ne = 'ne',
    Nl = 'nl',
    Nlbe = 'nl-be',
    Nn = 'nn',
    No = 'no',
    Pa = 'pa',
    Pl = 'pl',
    Pt = 'pt',
    Ptbr = 'pt-br',
    Rm = 'rm',
    Ro = 'ro',
    Romd = 'ro-md',
    Ru = 'ru',
    Rumd = 'ru-md',
    Sb = 'sb',
    Sk = 'sk',
    Sl = 'sl',
    Sq = 'sq',
    Sr = 'sr',
    Sv = 'sv',
    Svfi = 'sv-fi',
    Th = 'th',
    Tn = 'tn',
    Tr = 'tr',
    Ts = 'ts',
    Ua = 'ua',
    Ur = 'ur',
    Ve = 've',
    Vi = 'vi',
    Xh = 'xh',
    Zhcn = 'zh-cn',
    Zhhk = 'zh-hk',
    Zhsg = 'zh-sg',
    Zhtw = 'zh-tw',
    Zu = 'zu',
}
